<template>
  <div>
    <div class="container-table-striped">
      <div class="table-hover">
        <div v-for="(item, index) in items" :key="index">
          <div class="period-panel py-3 rounded">
            <div class="row">
              <div class="col d-flex flex-row justify-content-start">
                <custom-icon-view
                  icon="fa fa-calendar"
                  icon-color="#fff"
                  icon-background="#FF7058"
                  gradient
                  variant="d-inline w-auto"
                />
                <strong
                  class="d-block font-18 font-weight-bold mt-0 ml-n4 d-flex align-items-center"
                >
                  Año Académico: {{ item.evaluationAcademicYearName }}
                </strong>
              </div>
              <div
                class="col d-flex justify-content-end align-items-center pr-5"
              >
                <span class="d-block ml-5 font-15">
                  Revisión Trianual - {{ item.evaluationDateTransactionId }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <callout
              :has-toggle="true"
              class="mb-3 mt-1"
              :opened="item.isOpenA"
              :controlled="true"
              @click:open="onOpenDetails(item, 'A')"
            >
              <div class="row">
                <div class="col-md-3 col-sm-12 border-right py-4 pl-5">
                  <div class="data-field-title">
                    Análisis de Evaluación Existente
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="row pt-2">
                    <div class="col-md-4 pl-5">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Fecha:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        <span>{{ dateFormat(item.evaluationDate) }}</span>
                      </span>
                    </div>
                    <div class="col-md-4">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Solicitado por:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        <span>{{ item.evaluationCreatedBy }}</span>
                      </span>
                    </div>
                    <div class="col-md-2 d-flex align-items-center">
                      <strong class="font-16 color-black--2 font-weight-bold">
                        Suficiente:
                      </strong>
                      <span
                        class="font-16 color-black--2 font-weight-bold ml-1"
                      >
                        {{ item.isSufficient }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-2 text-right pr-5 d-flex justify-content-end align-items-center"
                >
                  <div class="dropdown">
                    <button
                      class="btn btn-dropdown-actions dropdown-toggle pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div class="dropdown-menu pb-0">
                      <a
                        v-if="item.hasTriannual && hasVerPermission"
                        class="drop-item cursor-pointer"
                        @click="
                          goToDeterminacionElegibilidad(item.evaluationDateId)
                        "
                      >
                        <i class="fas fa-file-search text-green pr-1" />
                        <span>Ver</span>
                      </a>
                      <a
                        v-if="!item.hasTriannual"
                        class="drop-item cursor-pointer"
                        @click="
                          goToDeterminacionElegibilidadEdit(
                            item.evaluationDateId
                          )
                        "
                      >
                        <i class="fas text-green fa-pencil-alt pr-3" />
                        <span>Editar</span>
                      </a>
                      <a
                        v-if="!item.isSufficientFlag"
                        class="drop-item cursor-pointer"
                        @click="goToDownloadEE05Report(item.evaluationDateId)"
                      >
                        <i class="fas text-green fa-file-alt pr-2" />
                        <span>Imprimir</span>
                      </a>
                      <a
                        v-if="
                          !item.hasTriannual &&
                            (hasDeletePermission ||
                              hasDeleteAnalysisExistingPermission)
                        "
                        class="drop-item cursor-pointer"
                        @click="
                          deleteAnalysisExistingInformation(
                            item.evaluationDateId,
                            false
                          )
                        "
                      >
                        <i class="fas text-red fa-times-circle pr-2" />
                        <span>Eliminar</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <template #edition>
                <div class="bg-gray p-2">
                  <div class="bg-white rounded p-3">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-2" />
                        <span class="color-black--3 font-weight-bold font-16">
                          Comentario
                        </span>
                      </div>
                      <div class="col ml-4 mt-n3">
                        <span class="font-weight-normal font-16 color-black--2">
                          {{ item.evaluationDateComment }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </callout>

            <callout
              :has-toggle="true"
              class="mb-3"
              :opened="item.isOpenB"
              :controlled="true"
              @click:open="onOpenDetails(item, 'B')"
            >
              <div class="row">
                <div class="col-md-3 col-sm-12 border-right py-4 pl-5">
                  <div class="data-field-title">
                    Revisión Trianual
                  </div>
                </div>
                <div
                  v-if="!item.hasTriannual"
                  class="col-md-9 d-flex align-items-center"
                >
                  <div class="row w-100 mt-2">
                    <div class="col-md-6 col-sm-12 pl-5">
                      <Error
                        variant="text-center no-border"
                        :message="resources['0513']"
                        is-alert-mode
                      />
                    </div>
                    <div
                      class="col-md-6 col-sm-12 pr-2 d-flex justify-content-end"
                    >
                      <ActionButton
                        v-if="hasEditPermission"
                        class="btn btn-success success"
                        i="fas fa-file-alt"
                        type="button"
                        @click="
                          determination(goDetermination, item.evaluationDate)
                        "
                      >
                        Determinación
                      </ActionButton>
                    </div>
                  </div>
                </div>
                <div v-if="item.hasTriannual" class="col-md-7">
                  <div class="row">
                    <div class="col-md-4 pl-5">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Fecha:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        <span>
                          {{ dateFormat(item.placementEvaluationDate) }}
                        </span>
                      </span>
                    </div>
                    <div class="col-md-4">
                      <div class="font-weight-normal font-14 color-gray--6">
                        Solicitado por:
                      </div>
                      <span class="font-weight-normal font-16 color-black--2">
                        <span>{{ item.evaluationCreatedBy }}</span>
                      </span>
                    </div>
                    <div class="col-md-2 d-flex align-items-center">
                      <strong class="font-16 color-black--2 font-weight-bold">
                        Elegible:
                      </strong>
                      <span
                        class="font-16 color-black--2 font-weight-bold ml-1"
                      >
                        {{ item.isElegible }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.hasTriannual"
                  class="col-md-2 text-right pr-5 d-flex justify-content-end align-items-center"
                >
                  <div class="dropdown">
                    <button
                      class="btn btn-dropdown-actions dropdown-toggle pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div class="dropdown-menu pb-0">
                      <a
                        v-if="hasVerPermission"
                        class="drop-item cursor-pointer"
                        @click="
                          goToDeterminacionElegibilidad(
                            item.evaluationDateId,
                            true
                          )
                        "
                      >
                        <i class="fas fa-file-search text-green pr-1" />
                        <span>Ver</span>
                      </a>
                      <a
                        class="drop-item cursor-pointer"
                        @click="
                          goToDownloadEE05Report(item.evaluationDateId, true)
                        "
                      >
                        <i class="fas text-green fa-file-alt pr-2" />
                        <span>Imprimir</span>
                      </a>
                      <a
                        v-if="
                          hasDeletePermission && item.isStudentLastTransaction
                        "
                        class="drop-item cursor-pointer"
                        @click="
                          deleteAnalysisExistingInformation(
                            item.evaluationDateId,
                            true
                          )
                        "
                      >
                        <i class="fas text-red fa-times-circle pr-2" />
                        <span>Eliminar</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <template #edition>
                <div class="bg-gray p-2">
                  <div class="bg-white rounded p-3">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-2" />
                        <span class="color-black--3 font-weight-bold font-16">
                          Información Adicional
                        </span>
                      </div>
                      <div class="col-md-12 ml-4 mt-n2">
                        <strong
                          class="d-block font-weight-normal font-14 color-gray--6"
                        >
                          Impedimento:
                        </strong>
                        <span class="font-weight-normal font-16 color-black--2">
                          {{ item.studentImpediment }}
                        </span>
                      </div>
                      <div class="col-md-12 ml-4 mt-3">
                        <strong
                          class="d-block font-weight-normal font-14 color-gray--6"
                        >
                          Comentario:
                        </strong>
                        <span
                          v-if="item.hasTriannual"
                          class="font-weight-normal font-16 color-black--2"
                        >
                          {{ item.placementComment }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </callout>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ActionButton, Error } from "@/components/common";
import Callout from "@/components/common/callout/View.vue";
import CustomIconView from "@/components/common/CustomIconView.vue";
import store from "@/store/index";
import generalService from "@/services/pei/general";
import mixAlert from "@/mixin/alert.mixin";
import resourcesService from "@/services/resources.js";
import StudentStatuses from "@/utils/constants/reg/studentStatuses.js";
import moment from "moment";
export default {
  name: "AnalysisExistingInformation",
  data: () => ({
    studentSieId: store.getters["$_student/StudentSie"],
    resources: [],
    optionsDD: [
      {
        Title: "Ver",
        Icon: "fa fa-check-square text-green"
      },
      {
        Title: "Eliminar",
        Icon: "fa fa-times-circle text-red"
      },
      {
        Title: "Editar",
        Icon: "fa fa-edit text-green"
      },
      {
        Title: "Imprimir",
        Icon: "fas text-green fa-file-alt mr-1"
      }
    ],
    goDetermination: {
      path: "/student/ProcessDeterminationTriannualEdit",
      query: {
        update: 1
      }
    }
  }),
  props: {
    items: Array
  },
  components: {
    ActionButton,
    Error,
    Callout,
    CustomIconView
  },
  computed: {
    selectedPlacementCommitteId() {
      if (this.$store.state.placementCommittee != undefined) {
        return this.$store.state.placementCommittee.placementCommitteId;
      }
      return undefined;
    },
    hasEditPermission() {
      return this.$store.getters.HasPermission("trianualevaluation.modify");
    },
    hasDeleteAnalysisExistingPermission() {
      return this.$store.getters.HasPermission(
        "student.processtriannual.deleteanalysisexistentevaluation"
      );
    },
    hasDeletePermission() {
      return this.$store.getters.HasPermission(
        "evaluaciontrianualanalisis.delete"
      );
    },
    hasVerPermission() {
      return this.$store.getters.HasPermission("trianualevaluation.ver");
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    isStudenElegible() {
      if (this.$store.getters.SelectedStudent != null) {
        let status = this.$store.getters.SelectedStudent.status;
        switch (status) {
          case StudentStatuses.Inactivo:
            return false;
          case StudentStatuses.Egreso:
            return false;
          default:
            return true;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    async goToDeterminacionElegibilidad(
      evaluationDateId,
      FromDetermination = false
    ) {
      this.$store.dispatch("setSelectedPeiEvaluationDateId", evaluationDateId);
      await this.fetchPlacementCommittee(evaluationDateId);
      await this.setSignaturePositions();
      let seeDetermination = {
        path: `/student/ProcessDeterminationTriannualView/${evaluationDateId}`,
        query: {
          isSubmitted: true,
          isFromDetermination: FromDetermination,
          isFromDetailCoordination: false,
        }
      };
      this.$router.push(seeDetermination);
    },
    async fetchPlacementCommittee(evaluationDateId) {
      await this.$ApiGet(
        `/api/triannualstudentevaluation/getplacementcommittee/${evaluationDateId}`
      )
        .then(res => {
          this.placementCommittee = res.data;
          this.$store.dispatch(
            "setSelectedPlacementCommitte",
            this.placementCommittee
          );
        })
        .catch(err => {
          this.response = err;
        });
    },
    async setSignaturePositions() {
      let endpoint = "";
      let self = this;
      endpoint =
        process.env.VUE_APP_URL_API +
        `/api/signature/selectsignatureparticipants/${self.selectedPlacementCommitteId}`;

      self.$ApiGet(endpoint).then(function(response) {
        let data = response.data;
        let tempSignatures = [];
        let i;
        for (i = 0; i < data.length; i++) {
          tempSignatures.push({
            attendanceArea: 0,
            groupId: 0,
            positionId: data[i].positionCode,
            name: data[i].fullName
          });
        }
        self.$store.dispatch("setSelectedSignatureParticipant", tempSignatures);
      });
    },
    goToDeterminacionElegibilidadEdit(evaluationDateId) {
      this.$router.push(
        `/student/ProcessDeterminationTriannualEdit/${evaluationDateId}`
      );
    },
    async goToDownloadEE05Report(evaluationDateId, isFromTriannual = false) {
      let self = this;
      let promise = new Promise(resolve => {
        self
          .$ApiGet(
            `/api/studentevaluation/${this.studentSieId}/TrianualEligibilityDeterminationForm/${evaluationDateId}/${isFromTriannual}`
          )
          .then(res => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch(err => {
            self.response = err;
          });
      });
      return promise;
    },
    async deleteAnalysisExistingInformation(evaluationDateId, hasTrianual) {
      let questionText = hasTrianual
        ? "¿Está seguro de que desea eliminar la determinación?"
        : "¿Está seguro de que desea eliminar el Análisis de Información Existente?";

      let answer = await mixAlert.methods.ShowCancelModal(
        this.resources["R90005"],
        questionText,
        this.resources["R90007"],
        this.resources["R90008"]
      );

      if (answer) {
        let self = this;
        let promise = new Promise(resolve => {
          self
            .$ApiPost(
              `/api/triannualstudentevaluation/deleteAnalysisExistingInformation/${evaluationDateId}/${hasTrianual}`
            )
            .then(res => {
              store.dispatch("$_student/refreshStudentMainInfo");
              resolve(res.data);
              this.$emit("deleteAnalysisExistingInformation");
              mixAlert.methods.ShowToast(
                "",
                "La Información fue eliminada exitosamente",
                "success"
              );
            })
            .catch(err => {
              self.response = err;
              if (err && err.response && err.response.data)
                mixAlert.methods.ShowToast(
                  err.response.data.message,
                  "",
                  "error"
                );
              else mixAlert.methods.ShowToast(err.message, "", "error");
            });
        });
        return promise;
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        "R90005",
        "R90007",
        "R90008",
        "0513"
      ]);
    },
    determination(goDetermination, lastEvalDate = undefined) {
      if (!this.isStudenElegible) {
        mixAlert.methods.ShowToast(
          "No podrá realizar la determinación.",
          `No podrá realizar la determinación ya que el estudiante se encuentra en estatus ${this.studentStatus}.`,
          "error"
        );
        return;
      }
      if (lastEvalDate != undefined) {
        goDetermination.query.lastEvalDate = lastEvalDate;
      }

      this.$router.push(goDetermination);
    },
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale("es")
          .format("DD/MMM/YYYY");
      }

      return "";
    },
    onOpenDetails(item, side) {
      this.$emit("on-open-details", { ...item }, side);
    }
  },
  created() {
    this.loadResources();
  }
};
</script>

<style scoped>
.data-field-title {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

.move--relative {
  position: relative;
  left: 1%;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.period-panel {
  background: #e2e2e2 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 10px 0px 20px 20px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
